<template>
  <AppPrintButton :loading="loading" @export="visible = true"></AppPrintButton>
  <Dialog
    header="Recibo de venda"
    style="min-width: 300px; max-width: 750px"
    :modal="true"
    v-model:visible="visible"
  >
    <div class="p-grid">
      <div class="p-col-12 p-mb-2">
        Selecione abaixo as colunas que estarão presentes no relátorio.
      </div>
      <div class="p-col-6 p-sm-2">
        <div class="p-field-checkbox">
          <Checkbox
            name="earring"
            :modelValue="true"
            :binary="true"
            :disabled="true"
          />
          <label for="earring"> Brinco </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox
            name="type"
            :modelValue="true"
            :binary="true"
            :disabled="true"
          />
          <label for="type"> Tipo </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="breed" v-model="columns.breed" :binary="true" />
          <label for="breed"> Raça </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="weight" v-model="columns.weight" :binary="true" />
          <label for="weight"> Peso </label>
        </div>
      </div>
      <div class="p-col-6 p-sm-3">
        <div class="p-field-checkbox">
          <Checkbox
            name="birthDate"
            v-model="columns.birthDate"
            :binary="true"
          />
          <label for="birthDate"> Data de Nascimento </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="age" v-model="columns.age" :binary="true" />
          <label for="age"> Idade </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox
            name="bovineRoot"
            v-model="columns.bovineRoot"
            :binary="true"
          />
          <label for="bovineRoot"> Matriz </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="status" v-model="columns.status" :binary="true" />
          <label for="status"> Status </label>
        </div>
      </div>
      <div class="p-col-6 p-sm-2">
        <div class="p-field-checkbox">
          <Checkbox name="bullType" v-model="columns.bullType" :binary="true" />
          <label for="bullType"> Touro </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="color" v-model="columns.color" :binary="true" />
          <label for="color"> Cor </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="farmLot" v-model="columns.farmLot" :binary="true" />
          <label for="farmLot"> Lote/Piquete </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="owner" v-model="columns.owner" :binary="true" />
          <label for="owner"> Proprietário </label>
        </div>
      </div>
      <div class="p-col-6 p-sm-3">
        <div class="p-field-checkbox">
          <Checkbox
            name="childBirth"
            v-model="columns.childBirth"
            :binary="true"
          />
          <label for="childBirth"> Previsão de Parto </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="tags" v-model="columns.tags" :binary="true" />
          <label for="tags"> Etiquetas </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox
            name="observation"
            v-model="columns.observation"
            :binary="true"
          />
          <label for="observation"> Observação </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox name="calcType" v-model="columns.calcType" :binary="true" />
          <label for="calcType"> Tipo de cálculo </label>
        </div>
      </div>
      <div class="p-col-6 p-sm-2">
        <div class="p-field-checkbox">
          <Checkbox name="value" v-model="columns.value" :binary="true" />
          <label for="value"> Valor </label>
        </div>
        <div class="p-field-checkbox">
          <Checkbox
            name="totalValue"
            v-model="columns.totalValue"
            :binary="true"
          />
          <label for="totalValue"> Valor Total </label>
        </div>
      </div>
      <div class="p-col-12">
        <p>Por último, selecione a orientação do arquivo.</p>
      </div>
    </div>
    <div class="p-grid p-jc-end">
      <div class="p-col-fixed" style="padding-bottom: 0">
        <AutocompleteApi
          v-model:value="template"
          :search="fetchReportTemplate"
          :placeholder="'Modelo'"
        ></AutocompleteApi>
      </div>
      <div class="p-col-fixed" style="padding-bottom: 0">
        <AppButton label="Ok" @click="generateReceipt()" />
      </div>
    </div>
  </Dialog>
</template>

<script>
import debounce from 'debounce';
import AutocompleteApi from '../../../components/AutocompleteApi.vue';
import { ReportTemplateApi, SaleApi } from '../../../services/api';

const getDefaultColumns = () => ({
  breed: true,
  weight: true,
  birthDate: true,
  age: true,
  bovineRoot: false,
  bullType: false,
  color: false,
  farmLot: false,
  owner: false,
  childBirth: false,
  tags: false,
  observation: false,
  calcType: true,
  value: true,
  totalValue: true,
});

export default {
  name: 'SaleReceipt',
  props: {
    saleId: [Number, String],
  },
  components: {
    AutocompleteApi,
  },
  data() {
    return {
      loading: false,
      visible: false,
      template: null,
      columns: getDefaultColumns(),
    };
  },
  methods: {
    fetchReportTemplate: ReportTemplateApi.fetch,
    generateReceipt: debounce(
      async function generateReceipt() {
        try {
          this.visible = false;
          this.loading = true;
          const id = this.saleId;
          const date = this.$dayjs(this.date).format('DD-MM-YYYY');
          const filename = `Recibo da Venda - ${id} - ${date}.pdf`;
          const columns = Object.keys(this.columns).reduce((final, key) => {
            if (this.columns[key]) {
              final.push(key);
            }
            return final;
          }, []);
          const data = await SaleApi.receipt(this.saleId, {
            template: this.template?.id || undefined,
            columns: columns.join(','),
          });
          this.$downloadFile(filename, data);
        } finally {
          this.loading = false;
        }
      },
      500,
      true
    ),
  },
};
</script>

<style>
</style>
